var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.5 13c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.121C5.5 15.605 5.5 16.07 5.5 17v1.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C7.78 23 8.62 23 10.3 23h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V17c0-.93 0-1.395-.102-1.777a3 3 0 0 0-2.122-2.12C20.895 13 20.43 13 19.5 13m-1-4-4-4m0 0-4 4m4-4v12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.98521b9bf725960e0eb489329154c3f7.svg";
export { ForwardRef as ReactComponent };